import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBYLomL_ackHAkzm221sFA1c8aA2taggA4",
  authDomain: "facebook-clone-ce5eb.firebaseapp.com",
  databaseURL: "https://facebook-clone-ce5eb.firebaseio.com",
  projectId: "facebook-clone-ce5eb",
  storageBucket: "facebook-clone-ce5eb.appspot.com",
  messagingSenderId: "693244824686",
  appId: "1:693244824686:web:32f5249b01877df9c9ea7f",
  measurementId: "G-D8BYDGBYFL"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;
